export const getDGText = individualPackage => {
  if (individualPackage.labelStatus == 'incorrect') {
    return 'Incorrect';
  } else if (individualPackage.labelStatus == 'manually_corrected') {
    return 'Manually corrected';
  } else if (
    individualPackage.labelVisible == 'not_visible' &&
    individualPackage.labelStatus == 'correct'
  ) {
    return 'Obscured';
  } else if (
    individualPackage.labelVisible == 'visible' &&
    individualPackage.labelStatus == 'correct'
  ) {
    return 'Correct';
  } else return 'Unknown';
};
